import { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";
import { api } from "../lib/api";

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [dismissedIds, setDismissedIds] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("msq_dismissed_ann") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    api
      .get("/site/announcements")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);

  const visible = items.find((a) => !dismissedIds.includes(a.id));
  if (!visible) return null;

  const dismiss = () => {
    const next = [...dismissedIds, visible.id];
    setDismissedIds(next);
    sessionStorage.setItem("msq_dismissed_ann", JSON.stringify(next));
  };

  return (
    <div
      className="bg-slate-900 text-white text-sm"
      data-testid="announcement-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          <Megaphone className="h-4 w-4 text-[#FEF08A] shrink-0" />
          <p className="truncate font-medium">{visible.message}</p>
          {visible.link_url && (
            <a
              href={visible.link_url}
              target={visible.link_url.startsWith("http") ? "_blank" : undefined}
              rel="noreferrer"
              className="underline underline-offset-4 font-bold hover:text-[#FEF08A] whitespace-nowrap"
              data-testid="announcement-link"
            >
              {visible.link_label || "Learn more"}
            </a>
          )}
        </div>
        <button
          onClick={dismiss}
          className="text-slate-400 hover:text-white shrink-0"
          aria-label="Dismiss"
          data-testid="announcement-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
